export const links = ["login", "events", "products", "profile", "joinUs"];
